const KEY = 'pb3_session_v1';

const safeParse = (s) => {
  try { return JSON.parse(s); } catch { return null; }
};

export function getSession() {
  const raw = sessionStorage.getItem(KEY);
  return safeParse(raw) || {};
}

export function setSession(patch) {
  const cur = getSession();
  const next = { ...cur, ...patch };
  sessionStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearSession() {
  sessionStorage.removeItem(KEY);
}

export function requireFields(fields = []) {
  const data = getSession();
  const missing = fields.filter((f) => !data[f]);
  return { ok: missing.length === 0, missing, data };
}
